export const PDF_LESSONS_AR = [
  {
    id: 'pdf-1',
    numero: 1,
    titre: "فتح وقراءة ملف PDF",
    sousTitre: "الأساسيات",
    contexte: "تلقيت ملف PDF ولا تعرف كيف تفتحه. لا تقلق — الأمر أبسط مما تعتقد.",
    explication: [
      "**PDF** هو تنسيق ملف يحافظ على مظهر الوثيقة على أي جهاز. معظم الوثائق الرسمية تأتي بهذا التنسيق.",
      "**على الكمبيوتر**: انقر مرتين على الملف — يفتح تلقائياً. إذا لم يفتح، حمّل Adobe Acrobat Reader مجاناً.",
      "**على الهاتف**: PDF يفتح مباشرة بالنقر عليه. على iPhone يفتح بتطبيق Fichiers، على Android بتطبيق Files.",
      "**التكبير**: استخدم Ctrl+ على الكمبيوتر أو بصبعين على الهاتف لتكبير النص إذا كان صغيراً.",
      "**إذا لم تستطع الفتح**: تحقق من اتصال الإنترنت ومن أن الملف اكتمل تحميله — أحياناً ملف محمّل جزئياً لا يفتح.",
    ],
    question: "كيف تكبّر نصاً في ملف PDF على هاتفك؟",
    options: [
      { id: 'a', text: "بوضع إصبعين وتوسيعهما على الشاشة", correct: true },
      { id: 'b', text: "بالنقر المزدوج فقط وليس بطريقة أخرى", correct: false },
      { id: 'c', text: "لا يمكن تكبير PDF على الهاتف", correct: false },
    ],
    explication_reponse: "حركة التكبير بإصبعين تعمل على جميع الهواتف الذكية. يمكنك أيضاً النقر المزدوج لتكبير سريع.",
  },
  {
    id: 'pdf-2',
    numero: 2,
    titre: "ملء نموذج PDF",
    sousTitre: "بدون طباعة",
    contexte: "عليك ملء نموذج PDF وإرساله. كيف تفعل ذلك مباشرة على الكمبيوتر؟",
    explication: [
      "**نماذج PDF التفاعلية**: لها خانات يمكن النقر عليها لكتابة النص مباشرة. ابحث عن الخانات الزرقاء أو المستطيلات.",
      "**مفتاح Tab**: ينقلك من خانة إلى التالية بسرعة دون الحاجة لاستخدام الفأرة في كل مرة.",
      "**إذا كان PDF صورة**: الخانات غير قابلة للنقر. الحل: اطبعه، اmlأه باليد، ثم افحصه.",
      "**الحفظ**: بعد الملء، Ctrl+S لحفظ الملف المُعبَّأ على جهازك. لا تنس الحفظ قبل الإرسال!",
      "**أدوات مجانية**: على ilovepdf.com يمكنك ملء PDF مباشرة في المتصفح بدون تثبيت أي برنامج.",
    ],
    question: "نموذج PDF لا يمكن النقر على خاناته. ما الحل؟",
    options: [
      { id: 'a', text: "طباعته، ملؤه باليد، ثم فحصه وإرساله", correct: true },
      { id: 'b', text: "لا يمكن ملؤه إطلاقاً", correct: false },
      { id: 'c', text: "فتحه في Word وملؤه هناك", correct: false },
    ],
    explication_reponse: "PDF-صورة لا يمكن ملؤه رقمياً. الطباعة والكتابة باليد هي الحل الكلاسيكي. البديل هو استخدام أداة مثل ilovepdf.com التي تتيح أحياناً إضافة نص.",
  },
  {
    id: 'pdf-3',
    numero: 3,
    titre: "التوقيع على PDF",
    sousTitre: "3 طرق قانونية",
    contexte: "وثيقة تتطلب توقيعك. هل التوقيع الإلكتروني قانوني في فرنسا؟ نعم — إليك كيف.",
    explication: [
      "**التوقيع الإلكتروني قانوني** في فرنسا منذ 2000. مقبول لمعظم الوثائق الإدارية والتجارية.",
      "**الطريقة 1**: على Adobe Acrobat ← 'ملء وتوقيع' ← ارسم توقيعك بالفأرة أو أدخله كصورة.",
      "**الطريقة 2**: اطبع، وقّع باليد، افحص بهاتفك، أرسل PDF المفحوص.",
      "**الطريقة 3**: على ilovepdf.com أو smallpdf.com — أدوات توقيع مجانية عبر المتصفح.",
      "**توقيع مؤهَّل**: لوثائق حساسة جداً (عقود، محضر تلقٍّ)، استخدم خدمة مثل DocuSign أو Yousign.",
    ],
    question: "هل التوقيع الإلكتروني على PDF قانوني في فرنسا؟",
    options: [
      { id: 'a', text: "نعم، قانوني منذ 2000", correct: true },
      { id: 'b', text: "لا، فقط التوقيع اليدوي مقبول", correct: false },
      { id: 'c', text: "نعم لكن فقط للوثائق الخاصة وليس الإدارية", correct: false },
    ],
    explication_reponse: "التوقيع الإلكتروني قانوني في فرنسا وفي الاتحاد الأوروبي. مقبول لمعظم الوثائق. للوثائق الحساسة جداً، استخدم خدمة توقيع مؤهَّلة.",
  },
  {
    id: 'pdf-4',
    numero: 4,
    titre: "إرسال PDF بالبريد الإلكتروني",
    sousTitre: "مرفق ناجح",
    contexte: "ملفك جاهز. كيف ترفقه بالبريد وتتأكد من وصوله بشكل صحيح؟",
    explication: [
      "**إرفاق الملف**: في بريدك الإلكتروني، انقر على أيقونة المشبك 📎، ابحث عن ملف PDF في جهازك، انقر عليه.",
      "**الحجم الأقصى**: معظم خوادم البريد تقبل مرفقات حتى 5 ميغابايت. إذا كان أكبر، استخدم ilovepdf.com لضغطه.",
      "**التحقق قبل الإرسال**: تأكد أن الملف ظهر كمرفق (اسمه يظهر أسفل البريد) قبل النقر على إرسال.",
      "**اسم الملف**: أعطِ الملف اسماً واضحاً قبل إرساله — مثلاً 'JustificatifDomicile_NomPrenom.pdf' بدلاً من 'scan001.pdf'.",
      "**طلب إيصال الاستلام**: للوثائق المهمة، اطلب من المرسَل إليه تأكيداً باستلامه — أو استخدم خاصية 'طلب قراءة'.",
    ],
    question: "ملف PDF يزن 8 ميغابايت. كيف ترسله بالبريد؟",
    options: [
      { id: 'a', text: "اضغطه أولاً على ilovepdf.com ثم أرسله", correct: true },
      { id: 'b', text: "أرسله كما هو — البريد يضغطه تلقائياً", correct: false },
      { id: 'c', text: "لا يمكن إرسال PDF بهذا الحجم", correct: false },
    ],
    explication_reponse: "ilovepdf.com يضغط PDF مجاناً دون فقدان الجودة. بعد الضغط، حجم الملف ينخفض عادةً إلى أقل من 2 ميغابايت — سهل الإرسال.",
  },
];
